import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCredencialesRdp } from '../../helpers/api_helper';

const useObtenerCredencialesRdp = (refresh = 0) => {
    const [credenciales, setCredenciales] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchCredenciales = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getCredencialesRdp({ tenantId, empresa });
                setCredenciales(response);
            } catch (err) {
                const errorMessage = `Failed to fetch Credenciales RDP: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setCredenciales(null);
            } finally {
                setLoading(false);
            }
        };

        fetchCredenciales();
    }, [tenantId, empresa, refresh]);

    return { credenciales, loading, error };
};

export default useObtenerCredencialesRdp;
